"use client";

import React from "react";

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

import { ListOption } from "@/components/flowbite/list-option/list-option";
import { MoreVertIcon } from "@/components/icons-lib";
import { cn } from "@/shared/helpers/cn.helper";

import type { ActionsMenuDropdownAction } from "./actions-menu-dropdown";

interface ActionsMenuPopoverProps {
  actions: ActionsMenuDropdownAction[];
  triggerClassName?: string;
  ariaLabel?: string;
}

export const ActionsMenuPopover: React.FC<ActionsMenuPopoverProps> = ({
  actions,
  triggerClassName,
  ariaLabel = "Actions menu",
}) => {
  if (actions.length === 0) return null;

  return (
    <Popover className="relative inline-flex items-center justify-center">
      <PopoverButton
        aria-label={ariaLabel}
        className={cn(
          "inline-flex h-6 w-6 shrink-0 items-center justify-center rounded transition-colors duration-300",
          triggerClassName,
        )}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <MoreVertIcon className="h-6 w-6 text-btn-icon" />
      </PopoverButton>
      <PopoverPanel
        anchor="bottom end"
        className="z-[60] mt-1 w-max min-w-[13.5rem] rounded-xl border border-gray-200 bg-white p-1 shadow-lg"
      >
        {({ close }) => (
          <div className="flex w-max min-w-[13.5rem] flex-col">
            {actions.map((action) => (
              <ListOption
                key={action.label}
                className={cn(
                  "w-full cursor-pointer justify-start whitespace-nowrap rounded-lg transition-colors duration-300 hover:bg-gray-100",
                  action.className,
                )}
                icon={action.icon}
                label={action.label}
                size="small"
                onClick={(e: React.MouseEvent) => {
                  e.stopPropagation();
                  action.onClick();
                  close();
                }}
              />
            ))}
          </div>
        )}
      </PopoverPanel>
    </Popover>
  );
};
